import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { SharedService } from '../shared.service';
import { ResetPasswordService } from './reset-password.service';
import { ResetPassword } from '../shared.model';
import { BaseUtils } from '../core/baseUtils.service';
@Component({
  selector: 'ba-reset-password',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
  userId: number;
  resetPassword: ResetPassword;
  resetPasswordModal: boolean;
  editConnectorRouterPath: string = "connectors/editConnector/:id";
  connectorResetPassword: boolean = false;
  profileResetPassword: boolean = true;
  @ViewChild('resetPasswordForm', { static: true }) resetPasswordForm: any;
  @Output() resetPasswordModalState = new EventEmitter();
  constructor(
    public activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    public sharedService: SharedService,
    public messageService: MessageService,
    public resetPasswordService: ResetPasswordService,
    public baseUtils: BaseUtils
  ) {
    this.resetPassword = new ResetPassword();

  }

  ngOnInit() {
    if (this.activatedRoute.routeConfig.path === this.editConnectorRouterPath) {
      this.connectorResetPassword = true;
    }
    this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
      this.userId = +params.get('id');
    });

    if (this.userId) {
      this.profileResetPassword = false;
    }
  }

  /**
   * To reset logged in user password
   * @param data Updated password data
   */
  resetUserPassword(data: any) {
    if (data.newPassword === data.confirmPassword) {
      this.baseUtils.loading_spinner(true);
      this.resetPasswordService.resetUserPassword(data, this.userId, this.connectorResetPassword)
        .subscribe(() => {
          this.resetPasswordModalState.emit(false);
          this.baseUtils.loading_spinner(false);
          this.baseUtils.toasterMessageAction('success', 'MESSAGES.PASSWORD_CHANGED', '')
        }, (error) => {
          this.resetPasswordForm.submitted = false;
          this.baseUtils.loading_spinner(false);
          this.sharedService.serverErrorHandler(error);
        });
    } else {
      this.resetPasswordForm.submitted = false;
      this.baseUtils.toasterMessageAction('error', 'MESSAGES.PASSWORD_MATCH', '')
    }
  }

  closeModal() {
    this.connectorResetPassword = false;
    this.resetPasswordModalState.emit(false);
  }

}
